import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/Index'
import ItemIndex from '@/components/item/ItemIndex'
import ItemMenu from '@/components/item/ItemMenu'
import ItemDesc from '@/components/item/ItemDesc'
import ContactIndex from '@/components/contact/ContactIndex'
import MessageIndex from '@/components/message/MessageIndex'
import SummarizedIndex from '@/components/summarized/SummarizedIndex'
import AftermarketIndex from '@/components/aftermarket/AftermarketIndex'
import NewsIndex from '@/components/news/NewsIndex'
import NewsMenu from '@/components/news/NewsMenu'
import NewsDesc from '@/components/news/NewsDesc'
import Outbox from '@/components/index/Outbox'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
      path: '/',
      name: 'Index',
      component: Index
    }, {
      path: '/item',
      component: ItemIndex,
      children: [{
          path: 'index',
          component: ItemMenu,
        }, {
          path: 'search',
          component: ItemMenu,
        },
        {
          path: 'desc',
          name: 'ItemDesc',
          component: ItemDesc,
        }
      ]
    },
    {
      path: '/contact',
      name: 'ContactIndex',
      component: ContactIndex
    },
    {
      path: '/message',
      name: 'MessageIndex',
      component: MessageIndex
    },
    {
      path: '/summarized',
      name: 'SummarizedIndex',
      component: SummarizedIndex
    },
    {
      path: '/aftermarket',
      name: 'AftermarketIndex',
      component: AftermarketIndex
    },
    {
      path: '/news',
      component: NewsIndex,
      children: [{
        path: 'index',
        name: 'NewsMenu',
        component: NewsMenu,
      }, {
        path: 'desc',
        name: 'NewsDesc',
        component: NewsDesc,
      }]
    }
  ],
  mode: "history"
})



// WEBPACK FOOTER //
// ./src/router/index.js